import * as Prismic from "prismic-javascript";
import _ = require("lodash");

interface IDInfo {
    id: string;
    customType: string;
    path?: string;
}
export default class PrismicHelper {
    private apiEndpoint = "https://mathfluency-games.prismic.io/api/v2";
    private client;
    private customTypes = [
        "questions",
        "items",
        "attributes",
        "numberlineRange"
    ];

    public async getEntry(req: string): Promise<{}> {
        this.client = await Prismic.getApi(this.apiEndpoint);
        try {
            const { data } = await this.client.getByID(req);
            _.assign(data, { uid: req });
            await this.fetchAllLinkedItemsUsingData(data);
            return data;
        } catch (err) {
            console.log("Prismic error : ", err);
            return err;
        }
    }

    private async fetchAllLinkedItemsUsingData(data): Promise<void> {
        const idInfoArr: IDInfo[] = this.getLinkIDsInData(data);
        let ids = idInfoArr.map((idInfo: IDInfo) => idInfo.id);

        let finalResults:any = [];

        // Arrays of array of 20 (Divided ids array into chunks of 20)
        let chunkOf20 = await _.chunk(ids, 20);
        for (let i = 0; i < chunkOf20.length; i++) {
            let { results } = await this.client.getByIDs(chunkOf20[i]);
            finalResults = await _.concat(finalResults, results);
        }
        await this.mergeResultsToData(data, finalResults, idInfoArr);
    }
    private async mergeResultsToData(data, results, idInfoArr): Promise<void> {
        for (let idInfo of idInfoArr) {
            for (let result of results) {
                if (idInfo.id === result.id) {
                    await _.set(data, idInfo.path, _.assign(result.data, { uid: result.id }));
                    await this.fetchAllLinkedItemsUsingData(result.data);
                }
            }
        }
    }

    private getLinkIDsInData(responseDocument): any {
        const ids: IDInfo[] = [];
        this.customTypes.forEach((customType) => {
            const customTypeValue = _.get(responseDocument, customType);
            if (!customTypeValue) { return; }
            if (_.isArray(customTypeValue)) {
                customTypeValue.forEach((customTypeValueElement, i) => {
                    ids.push({
                        id: customTypeValueElement[Object.keys(customTypeValueElement)[0]].id,
                        path: `${customType}[${i}]`,
                        customType
                    });
                });
            } else {
                ids.push({
                    id: customTypeValue.id,
                    path: `${customType}`,
                    customType
                });
            }
        });
        return ids;
    }
}
